module.exports = __webpack_public_path__ + "media/fotografia_reel.894cf5e7.webm";